import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Table, Thead, Tbody, Tr, Th, Td, IconButton } from '@chakra-ui/react';
import { formatDateTime } from 'utils/date.util';

import { FaArrowRight } from 'react-icons/fa';

import { useColors } from './colors';

const SuppliersTable = ({ suppliers }) => {
  const navigate = useNavigate();
  const { textColor, borderColor } = useColors();

  return (
    <Table variant="simple" size="md">
      <Thead>
        <Tr>
          <Th color={textColor}>Supplier</Th>
          <Th color={textColor}>SKU Prefix</Th>
          <Th color={textColor}>Last Inventory Upload</Th>
          <Th color={textColor}>Last Shipping Upload</Th>
          <Th color={textColor}>Action</Th>
        </Tr>
      </Thead>
      <Tbody>
        {suppliers.map((supplier, idx) => (
          <Tr
            key={supplier._id || idx}
            borderBottom="1px solid"
            borderColor={borderColor}
            h="60px"
          >
            <Td color={textColor}>{supplier.altName}</Td>
            <Td color={textColor}>{supplier.skuPrefix}</Td>
            <Td color={textColor}>{formatDateTime(supplier.inventoryUpdatedDate)}</Td>
            <Td color={textColor}>{formatDateTime(supplier.shippingUpdatedDate)}</Td>
            <Td>
              <IconButton
                icon={<FaArrowRight />}
                colorScheme="blue"
                aria-label="Go to supplier page"
                onClick={() => navigate(`/admin/supplier/${supplier._id}`)}
              />
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default SuppliersTable;
